import * as o from "react";
import c from "../lib/IconBase.es.js";
import a from "../defs/StopCircle.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(c, { ref: t, ...r, weights: a }));
e.displayName = "StopCircleIcon";
const p = e;
export {
  p as StopCircle,
  e as StopCircleIcon
};
